export const GAME_CONFIG = {
  // World scale & camera
  world: {
    widthMeters: 100,
    heightMeters: 100,
    originLat: 21.0307, // Cau Giay / Ba Dinh, Hanoi
    originLon: 105.8015,
  },

  // Resource & Player Limits
  resources: {
    maxBagsPerWalk: 2, // Khởi đầu chỉ có đúng 2 túi nilon (Sinh tử môn)
    initialReputation: 100, // Thang điểm danh dự: 0 - 100
    cleanTimeMs: 3000, // 3 giây đứng dọn rác
    moveSpeed: 7.5, // 7.5 m/s tốc độ đi bộ nhanh nhạy, thấy rõ bước đi
    sprintSpeed: 10.0, // 10.0 m/s khi bấm chạy tháo thân
  },

  // Dog Behavior & Physics
  dog: {
    maxLeashLength: 3.5, // 3.5 mét chiều dài dây xích
    walkSpeed: 7.8, // Chó chạy lon ton 7.8 m/s bám sát gót chủ
    bowelsIncreasePerMeter: 0.45, // Mót ruột tăng theo quãng đường di chuyển
    criticalBowelsThreshold: 90, // >= 90% bắt đầu ghì chân, ngửi gốc cây
    poopDurationMs: 4000, // 4 giây xả phân tại chỗ
    leashStressRate: 25, // Cố kéo xích khi chó mót tăng 25 stress/giây
    barkAlertRadius: 18.0, // Tiếng chó sủa đánh động NPC trong bán kính 18m
    entanglementDurationMs: 3500, // Chó ngáo quấn xích: trói chân 3.5 giây
  },

  // Game Theory & Payoff Matrix (v3)
  gameTheory: {
    // Thưởng / Phạt Uy Tín
    repGainClean: 5, // Dọn sạch có người thấy: +5 điểm uy tín
    baseFineCaught: 20, // Phạt cơ bản khi bị bắt
    
    // Hệ số Nhục Nhã (The Disgrace Multiplier)
    disgraceMultiplier: {
      mainRoad: 1.0, // Bắt ở mặt đường lớn: x1.0 (Ý thức kém)
      darkAlley: 3.5, // Bắt ở ngõ khuất lén lút: x3.5 (Vừa bẩn vừa hèn)
      blameFailed: 7.0, // Sút bóng trượt bị ghi hình đá phân: x7.0 (Siêu ô nhục)
    },

    hiddenCamProbability: 0.05, // 5% nguy cơ bị quay lén từ rèm cửa sổ tầng 2
    quannuocSelfEsteemPenalty: 5, // Quán trà đá cà khịa dù có dọn: -5 điểm tự ái

    // Quick Time Event (QTE) Kick mini-game
    qte: {
      sweetSpotStart: 0.42,
      sweetSpotEnd: 0.62,
      cursorSpeed: 1.8, // tốc độ dao động của thanh lực
      maxKickDistance: 12, // sút xa tối đa 12 mét
    },

    // Repeat Game / Retaliation
    chiliTrapEffectRadius: 3.0,
    ownPoopSpeedDebuff: 0.5, // Dẫm phải bãi cũ: giảm 50% tốc độ

    // Dummy Walker Rivals & Game Theory Archetypes
    dummyWalkers: {
      chickenGameDist: 3.5, // 3.5 mét: chạm mặt kích hoạt Chicken Game
      chickenBowelsSurgeRate: 15.0, // +15% mót ruột/giây khi 2 con chó giằng co
      altruistVisionRange: 13.0,
      altruistFovRad: (120 * Math.PI) / 180,
      paranoiaMax: 100,
      paranoiaPerDefect: 25, // Mỗi bãi thằng lén lút xả bậy tăng 25 điểm Paranoia cả xóm
      paranoiaDecayRate: 0.6, // Tự hạ nhiệt dần theo thời gian
    },
  },

  // Surveillance & NPC
  surveillance: {
    inspector: {
      fovRad: (90 * Math.PI) / 180, // 90 độ nón tầm nhìn
      range: 16.0, // 16 mét tầm nhìn
      speed: 1.6, // tốc độ tuần tra của bác tổ trưởng
    },
    camera: {
      fovRad: (75 * Math.PI) / 180,
      range: 18.0,
      blinkIntervalMs: 1200,
    },
    teaStall: {
      radarRadius: 22.0, // 22 mét radar 360 độ chạy bằng cơm
    },
  },

  // Canvas visual colors & style
  render: {
    colors: {
      bg: '#181a20',
      road: '#272a34',
      sidewalk: '#313542',
      building: '#1f222b',
      buildingStroke: '#42485b',
      tree: '#2e7d32',
      wasteBasket: '#00acc1',
      leash: '#ffb300',
      player: '#29b6f6',
      dog: '#ffca28',
      poop: '#8d6e63',
      inspector: '#ef5350',
      visionCone: 'rgba(239, 83, 80, 0.18)',
      visionConeAlert: 'rgba(239, 83, 80, 0.45)',
      teaStall: '#ff7043',
      teaStallRadar: 'rgba(255, 112, 67, 0.12)',
      chiliTrap: '#d32f2f',
    },
  },
};
